import React, { useEffect, useState } from "react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import React, { useState } from "react";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  ConversationHeader,
  Avatar,
  MessageSeparator,
} from "@chatscope/chat-ui-kit-react";
import {
  Row,
  Col,
  Card,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import svgicon from "./sparkles-svgrepo-com.svg";
import Risesvg from "./ticket-information-svgrepo-com (1).svg";
import feedbacksvg from "./feedback-svgrepo-com.svg";
import suugestsvg from "./notes-note-svgrepo-com.svg";
import giffile from "./Logo gif.gif";
import config from "./config";
export default function MyReactComponent() {
  const [data, setData] = useState(null);
  const [, setLoading] = useState(true);
  const [license, setLicense] = useState(null);
  const [, setError] = useState(null);
  const [options, setOptions] = useState([]);
  const [KanbanMenumain, setKanbanMenumain] = useState([]);
  const [load, setLoad] = useState(false);
  const [load1, setLoad1] = useState(false);
  const [count, setCount] = useState(false);
  const [userData, setUserData] = useState(null);
  // State to track if chat box is open
  // useEffect(() => {
  //   const receviedmessage = (event) => {
  //     if (event.origin !== "http://localhost:3001") return;
  //     const data = event.data;
  //     console.log(event.data, "received message");
  //     localStorage.setItem("userid", data.userid);
  //   };
  //   window.addEventListener("message", receviedmessage);
  //   const storedata = localStorage.getItem("userid");
  //   if (storedata) {
  //     setid(storedata);
  //   }
  //   return () => {
  //     window.removeEventListener("message", receviedmessage);
  //   };
  // }, []);

  // useEffect(() => {
  //   const receiveMessage = (event) => {
  //     if (event.origin !== "http://localhost:3001") return;

  //     console.log("Received message:", event.data);
  //     const data = event.data;
  //     localStorage.setItem("userid", data.userid);
  //   };

  //   window.addEventListener("message", receiveMessage);

  //   const storedData = localStorage.getItem("userid");
  //   if (storedData) {
  //     setid(storedData);
  //   }

  //   return () => {
  //     window.removeEventListener("message", receiveMessage);
  //   };
  // }, []);
  // useEffect(() => {
  //   const receiveMessage = (event) => {
  //     // if (
  //     //   event.origin !== "https://web.devozy.ai" ||
  //     //   event.origin !== "http://129.126.198.5" ||
  //     //   event.origin !== "http://localhost:3001"
  //     // )
  //     //   return;
  //     if (event.origin !== "http://localhost:3001") {
  //       console.log("Unexpected origin: " + event.origin);
  //       // console.log("Unexpected origin: " + event.data);

  //       return;
  //     }

  //     console.log("Received message:", event.data);

  //     console.log(event.origin);
  //     const data = event.data;
  //     console.log("Received data:", data, event.orgin);
  //     setlocadata(data);
  //     // localStorage.setItem("userid", data.userid);
  //     // localStorage.setItem("username", data.username);
  //     // localStorage.setItem("email", data.email);
  //   };

  //   window.addEventListener("message", receiveMessage);

  //   // const storedid = localStorage.getItem("userid");
  //   // const storedusername = localStorage.getItem("username");
  //   // const storedemail = localStorage.getItem("email");
  //   // if (storedid) {
  //   //   setid(storedid);
  //   // }
  //   // if (storedusername) {
  //   //   setusername(storedusername);
  //   // }
  //   // if (storedemail) {
  //   //   setemail(storedemail);
  //   // }

  //   return () => {
  //     window.removeEventListener("message", receiveMessage);
  //   };
  // }, []);
  // console.log(localdata);

  // useEffect(() => {
  //   const receiveMessage = (event) => {
  //     // Filter out messages from unexpected origins
  //     if (event.origin !== "http://localhost:3001") {
  //       console.log("Unexpected origin:", event.origin);
  //       return;
  //     }

  //     const { userid, username, email } = event.data;
  //     // Do something with the received data
  //     console.log("Received message:", { userid, username, email });
  //   };

  //   // Add event listener to handle incoming messages
  //   window.addEventListener("message", receiveMessage);

  //   // Clean up event listener on component unmount
  //   return () => {
  //     window.removeEventListener("message", receiveMessage);
  //   };
  // }, []);
  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     if (event.origin === "http://localhost:3001") {
  //       const { userid, username, email } = event.data;
  //       console.log("Received data:", userid, username, email);
  //       // Handle the received data
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);

  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, []);

  // Run only once on component mount

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // Get the value of the 'license' parameter
    const licenseParam = params.get("license");
    const dataParam = params.get("data");
    // console.log(licenseParam);
    setLicense(licenseParam);
    if (dataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(dataParam));
        const sanitizedData = {
          userid: parsedData.userid || "",
          username: parsedData.username,
          email: parsedData.email,
          cliendId: parsedData.cliendId || "",
        };
        setUserData(sanitizedData);
      } catch (error) {
        console.error("Error parsing data parameter:", error);
      }
    }
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}/${licenseParam}`
          // `http://localhost:2001/api/v1/support/${licenseParam}`
          // `/subscription/support/${licenseParam}`
        );
        let _data = await response.data;
        setData(_data);

        setKanbanMenumain(response.data.data);

        setOptions(
          response.data.data?.[0]?.ChatDetails.filter((e) => e.Level === 1)?.[0]
            ?.Details
        );
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    window.parent.postMessage(
      {
        width: count ? "30vw" : "90px",
        height: count ? "82vh" : "90px",
      },
      "*"
    );
  }, [count]);

  // console.log(userData, "recived data");
  const [isOpen, setIsOpen] = useState(false);
  // console.log(data?.data?.ChatDetails.filter((e) => e.Level === 1)?.[0]?.Details);
  // console.log(data?.incidentcount);
  // console.log(localStorage.getItem("managerid"));
  // const hh = (e) => {
  //   alert("success");
  //   axios
  //     .get("/api/data")
  //     .then((response) => {
  //       console.log(response.data); // Log the fetched data
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  //   console.log(e);
  // };

  // const toggleChat = () => {
  //   setIsOpen(!isOpen);

  //   // Send a message to the parent window (child project) indicating the state change
  //   window.parent.postMessage({ isOpen: !isOpen }, "*");
  // };
  const [messages, setMessages] = useState([]);
  const [messages2, setMessages2] = useState([]);
  const [messages3, setMessages3] = useState([]);
  const [messages4, setMessages4] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOption2, setSelectedOption2] = useState(null);
  const [selectedOption3, setSelectedOption3] = useState(null);
  const [currentMessage, setcurrentMessage] = useState(null);
  const [finalmessage, setfinalMessage] = useState(false);
  const [senddisable, setsenddiable] = useState(true);
  const [bottype, setbottype] = useState("bot");
  useEffect(() => {
    if (selectedOption) {
      setsenddiable(false);
    } else {
      setsenddiable(true);
    }
  }, [selectedOption]);
  // woking
  const handleOptionClick = (option) => {
    let newMessage = "";

    if (option.Code === "SUBMITFEEDBACK") {
      newMessage =
        "We highly value your opinion. Kindly share your esteemed feedback";
    } else if (option.Code === "SUBMITANIDEA") {
      newMessage = "We value your insights. Please share your thoughts with us";
    } else {
      newMessage =
        "Which issue are you encountering? Here is a list of options for you.";
    }
    setbottype("agile");
    setMessages([...messages, newMessage]); // Add message indicating the selected option
    setSelectedOption(option); // Set selected option
    setOptions([]); // Disable all options by removing them
  };
  const handleOptionlevl2Click = (option2) => {
    setMessages2([`${option2.Title}`]); // Add message indicating the selected option
    setSelectedOption2(option2); // Set selected option
    // setOptions([]); // Disable all options by removing them
  };
  const handleOptionlevl3Click = (option3) => {
    setMessages3([`${option3.Title}`]); // Add message indicating the selected option
    setSelectedOption3(option3);
    setsenddiable(false); // Set selected option
    // setOptions([]); // Disable all options by removing them
  };
  // console.log(messages2);
  const handlechangeDes = (value) => {
    setcurrentMessage(value);
    setMessages4(value);
  };

  let level2data = KanbanMenumain?.[0]?.ChatDetails.find(
    (item) => item.Parent === selectedOption?.Code && item.Level === "2"
  );

  let level3data = KanbanMenumain?.[0]?.ChatDetails.find(
    (item) => item.Parent === selectedOption2?.Code && item.Level === "3"
  );
  const messageclear = () => {
    setMessages([]);
    setMessages2([]);
    setMessages3([]);
    setfinalMessage(false);
    setcurrentMessage(null);
    setSelectedOption(null);
    setSelectedOption2(null);
    setSelectedOption3(null);
    setAiInput("");
    setbottype("bot");
    setAiResponses([]);
    setOptions(
      KanbanMenumain?.[0]?.ChatDetails.filter((e) => e.Level === 1)?.[0]?.Details
    );
  };
  const handleSend = () => {
    setsenddiable(true);
    setcurrentMessage("");
    let incidentTitle = "";

    if (selectedOption2?.Title && selectedOption3?.Title) {
      incidentTitle = `${selectedOption2.Title}-${selectedOption3.Title}`;
    } else if (selectedOption2?.Title) {
      incidentTitle = selectedOption2.Title;
    } else if (selectedOption3?.Title) {
      incidentTitle = selectedOption3.Title;
    } else {
      incidentTitle = currentMessage;
    }

    if (selectedOption?.Desc && selectedOption?.Code !== "RAISEANISSUE") {
      incidentTitle = `${incidentTitle} - ${selectedOption.Desc}`;
    }

    let postdata = {
      token: license,
      incidentcount: data?.incidentcount,
      IncidentTitle: incidentTitle,
      Description: messages4 ? messages4 : "",
      SubCategoryCode: selectedOption?.Code,
      SubCategoryName: selectedOption?.Title,
      userid: userData?.userid,
      email: userData?.email,
      username: userData?.username,
    };
    // console.log(postdata,"post");
    setLoad(true);
    axios
      .post(`${config.API_BASE_URL}/`, postdata)
      // .post(`http://localhost:2001/api/v1/support/`, postdata)

      .then((res) => {
        // setLoading(false);
        // console.log(res.data, "post ");
        // axios.post(`agilesaas_incident_sla_details`, patchdatai).then((res) => {
        //   console.log(res.data);
        // });
        setfinalMessage(true);
        setLoad(false);
      })
      .catch((err) => {
        console.error(err);
        setLoad(false);
        setLoad1(true);
      });
  };

  const [aiResponses, setAiResponses] = useState([]); // aiResponses to hold bot messages
  const [aiInput, setAiInput] = useState(""); // aiInput to capture user input
  const [ailoading, setaiLoading] = useState(false);
  // console.log(aiInput);
  // Function to fetch the AI response
  const fetchAiResponse = async (userMessage) => {
    setaiLoading(true);
    const response = await fetch(`${config.API_BASE_URL}/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: userMessage,
        cliendId: userData?.cliendId || "", // Send the user's message as the query
      }),
    });

    if (response.ok) {
      const data = await response.json();
      const responseText =
        data.queryResult.responseMessages[0]?.text.text[0] ||
        "No response available";

      // Add the AI response message to the chat
      setAiResponses((prevResponses) => [
        ...prevResponses,
        { direction: "incoming", content: responseText },
      ]);
    } else {
      console.error("Failed to fetch AI response");
      setAiResponses((prevResponses) => [
        ...prevResponses,
        { direction: "incoming", content: "Failed to reach AI Bot" },
      ]);
    }
    setaiLoading(false);
  };

  // Handle sending the message and getting the response
  const handleSendMessage = (e) => {
    // e.preventDefault();

    // Add the user's input to the chat if it's not empty
    if (aiInput?.trim()) {
      setAiResponses((prevResponses) => [
        ...prevResponses,
        { direction: "outgoing", content: aiInput },
      ]);

      // Get the AI response for the user's input
      fetchAiResponse(aiInput);

      // Clear the input field after sending the message
      setAiInput("");
    }
  };
  const popovers = {
    "How to / What is":
      "Crete issue/task (or) plan a sprint (or) create pipeline (or) add subscriptions etc..  ",
    Projects:
      "Search for details about a specific project, such as its description, timeline, or updates or deployment",
    PLNxxxx:
      "Check the deployment status of the pipeline with ID PLNxxxx. Includes success, failure, or pending stages.",
    ENVxxxx:
      "Find environment-specific details like configuration, status, and deployment history.",
    ID: "Search for content using a unique identifier, such as project ID, task ID, or issue ID.",
    more: "Explore other keywords like date-wise searches (e.g., 'yesterday,' 'today','dd-mm-yy') or general devozy.ai related questions.",
  };

  const renderPopover = (content) => (
    <Popover className="py-2 px-3">
      <span style={{ fontSize: "0.85rem" }}>{content}</span>
    </Popover>
  );
  return (
    <div
      style={{
        position: "fixed",
        width: count ? "200px" : "90px",
        height: count ? "400px" : "90px",
        backgroundColor: "transparent",
      }}
    >
      {data && (
        <div>
          {/* <div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              zIndex: 999,
              backgroundColor: "transparent",
              // color: "lightblue",
              borderRadius: "50%",
            }}
          > */}
          <button
            className="shadow"
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              zIndex: 999,
              backgroundColor: "#FFFFFF",
              color: "#4792ff ",
              height: "55px",
              width: "55px",
              fontWeight: "bold",
              border: "1px solid rgb(238, 238, 238,0.5)",
              borderRadius: "50%", // Make it round
              // boxShadow: "0px  4px 9px rgba(0, 0, 0, 0.1)",
            }}
            // onClick={() => {
            //   setIsOpen(true);
            // }}
            onClick={() => {
              setIsOpen(true);
              setCount(!count);
            }}
          >
            {/* <h1 className="mt-1">
              <i className="fas fa-comment"></i>
            </h1> */}
            <div className="d-flex justify-content-center align-items-center ms-1">
              <img src={giffile} height={55} alt="DeSSA"></img>
            </div>
            DeSSA
          </button>
          {/* </div> */}

          {isOpen && (
            <div
              style={{
                // height: "450px  ",
                // width: "320px",
                position: "fixed",
                // bottom: "5px",
                // top: "10px",
                width: "100%",
                // right: "8px",
                // height: "100px",
                zIndex: 1000,
                height: "100%",
                // border: "1px solid red",
              }}
            >
              <MainContainer className="shadow-sm rounded-4 bg-info">
                <ChatContainer>
                  <ConversationHeader>
                    {/* <Avatar /> */}
                    <ConversationHeader.Content>
                      <div className="d-flex justify-content-between">
                        <span
                          style={{
                            color: "#000000",
                            alignSelf: "flex-center",
                            fontWeight: "bold",
                            fontSize: "0.90rem",
                          }}
                        >
                          {messages.length > 0 && (
                            <i
                              style={{ cursor: "pointer" }}
                              class="fa fa-arrow-left"
                              onClick={() => {
                                // setMessages([]);
                                // setMessages2([]);
                                // setMessages3([]);

                                // setSelectedOption(null);
                                // setSelectedOption2(null);
                                // setSelectedOption3(null);

                                // setOptions(
                                //   KanbanMenumain?.[0]?.ChatDetails.filter(
                                //     (e) => e.Level === 1
                                //   )?.[0]?.Details
                                // );
                                messageclear();
                              }}
                            ></i>
                          )}
                          &nbsp; <img src={svgicon} height={20} alt="icon"></img> Devozy.ai
                          Self Service Assistant (DeSSA){" "}
                        </span>

                        <span className="d-flex">
                          <button
                            // size="small"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                            className="d-flex justify-content-end mr-1"
                            onClick={() => {
                              setIsOpen(false);
                              setCount(!count);
                            }}
                          >
                            {/* <CloseIcon fontSize="inherit" /> */}
                            {/* <h5> */}
                            <i class="fa fa-minus"></i>
                            {/* </h5> */}
                          </button>
                          <button
                            // size="small"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                            className="d-flex justify-content-end ml-1"
                            onClick={() => {
                              setIsOpen(false);
                              messageclear();
                              setCount(!count);
                            }}
                          >
                            {/* <CloseIcon fontSize="inherit" /> */}
                            <i class="fa fa-times"></i>
                          </button>
                        </span>
                      </div>
                    </ConversationHeader.Content>
                  </ConversationHeader>
                  <MessageList>
                    {/* Render options as selectable messages */}
                    {messages?.length === 0 && (
                      <div className="ps-3 pt-1">
                        <span style={{ fontSize: "0.90rem" }}>
                          What whould you like to share with us today?
                        </span>
                      </div>
                    )}
                    {options?.map((option, index) => (
                      <div
                        className={" rounded-3 mx-1 mt-2 "}
                        key={index}
                        onClick={() => handleOptionClick(option)}
                        // onClick={() => handleOptionClick(option, 2)}
                        style={{
                          cursor: "pointer",
                          padding: "10px",
                          // boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                          color: selectedOption === option ? "gray" : "inherit",
                          // border: "1px solid rgb(246 246 246)",
                          backgroundColor: "#FFF",
                          alignItems: "center",
                          minHeight: "60px",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.border = "1px solid #5A88F1";
                          // e.currentTarget.style.color = "#FFFFFF";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.border =
                            "1px solid rgb(246 246 246)";
                          // e.currentTarget.style.color = "inherit";
                        }}
                      >
                        <Row className="mt-1">
                          <Col>
                            <div className="d-flex align-items-center py-1">
                              <img
                                className="ms-3"
                                src={
                                  option?.Code === "SUBMITFEEDBACK"
                                    ? feedbacksvg
                                    : option?.Code === "RAISEANISSUE"
                                    ? Risesvg
                                    : suugestsvg
                                }
                                height={22}
                                alt="option"
                              ></img>{" "}
                              <span
                                className="ms-3 ps-1"
                                style={{ fontSize: "0.95rem" }}
                              >
                                {" "}
                                {option.Title}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <i class="fa fa-arrow-right"></i>
                          </Col>
                        </Row>
                      </div>
                    ))}

                    {/* Render messages */}
                    {bottype === "bot" && (
                      <div>
                        <div>
                          <MessageSeparator>
                            <Avatar name="DeSSA" src={svgicon} size="xs" />
                            <span
                              className="pt-1"
                              style={{ fontSize: "0.75rem" }}
                            >
                              DeSSA
                            </span>
                          </MessageSeparator>
                        </div>
                        <div className="d-flex mt-1 justify-content-center">
                          {Object.entries(popovers).map(
                            ([key, content], index) => (
                              <OverlayTrigger
                                key={key}
                                placement="top"
                                overlay={renderPopover(content)}
                              >
                                <span
                                  className={`badge rounded-pill border text-bg-${
                                    index === 5 ? "secondary" : "light"
                                  } ms-2`}
                                  style={{ cursor: "pointer" }}
                                >
                                  {key}
                                </span>
                              </OverlayTrigger>
                            )
                          )}
                        </div>
                      </div>
                    )}
                    {messages?.map((message, index) => (
                      <div className="mt-2">
                        <Message
                          model={{
                            message: `Hello User`,
                            // sentTime: "just now",
                            sender: "You",
                            direction: "incoming",
                            position: "single",
                            // sender: "Joe",
                          }}
                          // className=""
                        ></Message>

                        <Message
                          key={`incoming-${index}`}
                          model={{
                            message,
                            // sentTime: "just now",
                            sender: "You",
                            direction: "incoming",
                            position: "single",
                            style: { color: "white" },
                          }}
                        >
                          <Message.Footer
                            sentTime={moment().format("hh:mm a")}
                          />
                        </Message>

                        {selectedOption?.Code === "SUBMITFEEDBACK" ||
                        selectedOption?.Code === "SUBMITANIDEA" ? null : (
                          <Message
                            key={`outgoing-${index}`}
                            model={{
                              // message,
                              // // sentTime: "just now",
                              // sender: "You",
                              direction: "outgoing",
                              position: "single",
                              type: "custom",
                            }}
                          >
                            {selectedOption && (
                              <Message.CustomContent>
                                {/* <Card>
                            <CardTitle>Please select the issue</CardTitle>
                            <CardBody> */}
                                {level2data ? (
                                  // <div

                                  //   style={{ width: "370px" }}
                                  // >
                                  <>
                                    <h6>Please select the options</h6>

                                    <div className="mt-2">
                                      {/* {level2data?.Details?.map((data, index) => (
                                      <div className="col p-1 mt-2" key={index}>
                                        <span
                                          className="p-1  rounded"
                                          style={{
                                            whiteSpace: "nowrap",
                                            border: "1px solid royalblue",
                                            backgroundColor: "#ffffff",
                                            color: "royalblue",
                                            cursor:
                                              messages3?.length > 0
                                                ? "default"
                                                : "pointer",
                                            transition: "background-color 0.3s",
                                          }}
                                          onMouseEnter={(e) => {
                                            if (messages3?.length === 0) {
                                              e.currentTarget.style.backgroundColor =
                                                "lightgrey";
                                              e.currentTarget.style.color =
                                                "#FFFFFF";
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (messages3?.length === 0) {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffffff";
                                              e.currentTarget.style.color =
                                                "royalblue";
                                            }
                                          }}
                                          key={index}
                                          onClick={() => {
                                            if (messages3?.length === 0)
                                              handleOptionlevl2Click(data);
                                          }}
                                          aria-disabled={messages3?.length > 0}
                                        >
                                          {data.Title}
                                        </span>
                                      </div>
                                    ))} */}
                                      {level2data?.Details?.map(
                                        (option, index) => (
                                          <div
                                            className={
                                              "shadow-sm rounded m-2 mt-3 "
                                            }
                                            key={index}
                                            onClick={() => {
                                              if (messages3?.length === 0)
                                                handleOptionlevl2Click(option);
                                            }}
                                            // onClick={() => handleOptionClick(option, 2)}
                                            style={{
                                              cursor: "pointer",
                                              padding: "10px",
                                              color:
                                                selectedOption === option
                                                  ? "gray"
                                                  : "inherit",
                                              // border: "1px solid #ccc",
                                              backgroundColor:
                                                "rgb(246 246 246)",
                                              alignItems: "center",
                                              minHeight: "50px",
                                              transition:
                                                "background-color 0.3s",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#5A88F1";
                                              e.currentTarget.style.color =
                                                "#FFFFFF";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "rgb(246 246 246)";
                                              e.currentTarget.style.color =
                                                "inherit";
                                            }}
                                          >
                                            <Row className="mt-1">
                                              <Col>
                                                <span style={{ marginLeft: 8 }}>
                                                  {option.Title}
                                                </span>
                                              </Col>
                                              <Col xs={2}>
                                                <i class="fa fa-arrow-right"></i>
                                              </Col>
                                            </Row>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </>
                                ) : // </div>
                                selectedOption?.Code === "SUBMITFEEDBACK" ? (
                                  "Give Your Valuable Feedback"
                                ) : (
                                  <label>Coming soon</label>
                                )}
                                {/* </CardBody>
                          </Card> */}
                              </Message.CustomContent>
                            )}
                            <Message.Footer
                              sentTime={moment().format("hh:mm a")}
                            />
                          </Message>
                        )}
                        {messages2?.length > 0 && (
                          <div className="mt-2">
                            <Message
                              key="outgoing-message"
                              model={{
                                message: messages2,
                                sender: "You",
                                direction: "outgoing",
                                position: "single",
                              }}
                              // className="custom-message"
                            >
                              <Message.Footer
                                sentTime={moment().format("hh:mm a")}
                              />
                            </Message>
                            <Message
                              key="incoming-message"
                              model={{
                                message: `Select the related issue ${messages2}`,
                                direction: "incoming",
                                position: "single",
                              }}
                            >
                              <Message.Footer
                                sentTime={moment().format("hh:mm a")}
                              />
                            </Message>
                            <Message
                              key="custom-message"
                              model={{
                                // message,
                                // // sentTime: "just now",
                                // sender: "You",
                                direction: "outgoing",
                                position: "single",
                                type: "custom",
                              }}
                            >
                              {selectedOption2 && (
                                <Message.CustomContent>
                                  {level3data ? (
                                    <div
                                      className="container"
                                      style={{ width: "240px" }}
                                    >
                                      <h6>Please select the options</h6>
                                      {/* <Divider /> */}
                                      <div className="row row-cols-md-1">
                                        {level3data?.Details?.map(
                                          (data1, index) => (
                                            <div
                                              className="col p-1 mt-2"
                                              key={index}
                                            >
                                              <span
                                                className="p-1  rounded"
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  border: "1px solid royalblue",
                                                  backgroundColor: "#ffffff",
                                                  color: "royalblue",
                                                  cursor: "pointer",
                                                  transition:
                                                    "background-color 0.3s",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "lightgrey";
                                                  e.currentTarget.style.color =
                                                    "#FFFFFF";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffffff";
                                                  e.currentTarget.style.color =
                                                    "royalblue";
                                                }}
                                                key={index}
                                                onClick={() =>
                                                  handleOptionlevl3Click(data1)
                                                }
                                              >
                                                {data1.Title}
                                              </span>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <label>Coming soon</label>
                                  )}
                                </Message.CustomContent>
                              )}
                              <Message.Footer
                                sentTime={moment().format("hh:mm a")}
                              />
                            </Message>
                            {messages3.length > 0 && (
                              <div>
                                <Message
                                  key="outgoing-message-2"
                                  model={{
                                    message: `${messages3}`,
                                    direction: "outgoing",
                                    position: "single",
                                  }}
                                >
                                  <Message.Footer
                                    sentTime={moment().format("hh:mm a")}
                                  />
                                </Message>
                                <Message
                                  key="incoming-message-2"
                                  model={{
                                    message: `Please provide a detailed description of your issue to create a new ticket`,
                                    direction: "incoming",
                                    position: "single",
                                  }}
                                >
                                  <Message.Footer
                                    sentTime={moment().format("hh:mm a")}
                                  />
                                </Message>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                    {load && (
                      <div
                        className=" d-flex align-items-center"
                        style={{ justifyContent: "center" }}
                      >
                        <span
                          className="spinner-border"
                          role="status"
                          aria-hidden="true"
                          style={{ color: "rgb(82, 80, 229)" }}
                        ></span>
                      </div>
                    )}
                    {finalmessage && (
                      <div>
                        <Message
                          key="outgoing-message-3"
                          model={{
                            message: messages4,
                            direction: "outgoing",
                            position: "single",
                          }}
                        ></Message>
                        <div className="d-flex justify-content-center mt-1 mb-1">
                          <Card
                            className="rounded shadow-sm p-1 mb-1"
                            style={{
                              width: "250px",
                              height: "100px",
                              border: "0.5px solid lightgreen",
                            }}
                          >
                            <Row>
                              <Col className="d-flex justify-content-center align-items-center">
                                <h2>
                                  <i
                                    className="fas fa-check-circle text-success"
                                    aria-hidden="true"
                                  ></i>
                                </h2>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex justify-content-center align-items-center">
                                <label className="font-weight-bold text-success">
                                  {selectedOption?.Code === "SUBMITFEEDBACK" &&
                                    "Thank you for your feedback. It has been recorded"}
                                  {selectedOption?.Code === "SUBMITANIDEA" &&
                                    "We've noted your idea and will consider it for devozy.ai soon"}
                                  {selectedOption?.Code !== "SUBMITFEEDBACK" &&
                                    selectedOption?.Code !== "SUBMITANIDEA" &&
                                    "Your ticket has been raised"}
                                </label>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </div>
                    )}
                    {load1 && (
                      <div className="d-flex justify-content-center mt-1 mb-1">
                        <Card
                          className="rounded shadow-sm p-1 mb-1"
                          style={{
                            width: "250px",
                            height: "100px",
                            border: "0.5px solid red",
                          }}
                        >
                          <Row>
                            <Col className="d-flex justify-content-center align-items-center">
                              <h2>
                                <i
                                  className="fas fa-check-circle text-danger"
                                  aria-hidden="true"
                                ></i>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex justify-content-center align-items-center">
                              <label className="font-weight-bold text-danger">
                                Something went wrong
                              </label>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    )}
                    {bottype === "bot" &&
                      aiResponses?.map((message, index) => (
                        <Message
                          key={index}
                          model={{
                            message: message.content,
                            direction: message.direction,
                            content: message.content,
                            position: "single",
                          }}
                          // avatarPosition="center-left"
                        >
                          {/* <Avatar
                            src="https://chatscope.io/storybook/react/assets/zoe-E7ZdmXF0.svg"
                            name="Zoe"
                            size="md"
                          /> */}
                        </Message>
                      ))}

                    {ailoading && (
                      <div class="dot-wave mb-3">
                        <div class="dot-wave__dot"></div>
                        <div class="dot-wave__dot"></div>
                        <div class="dot-wave__dot"></div>
                        <div class="dot-wave__dot"></div>
                        <div
                          className=" ms-2 mb-2"
                          style={{ color: "#0D92F4" }}
                        >
                          Processing...
                        </div>
                      </div>
                    )}
                  </MessageList>
                  {/* {ailoading && (
                    <Message>
                      <TypingIndicator content="Processing" />
                    </Message>
                  )} */}
                  {/* <MessageList className="border">
                    {aiResponses.map((message, index) => (
                      <Message
                        key={index}
                        model={{
                          message: message.content,
                          direction: message.direction,
                          content: message.content,
                          position: "single",
                        }}
                       
                      >
                        
                      </Message>
                    ))}
                    {ailoading && <TypingIndicator content="Processing" />}
                  </MessageList> */}
                  {bottype !== "bot" ? (
                    <MessageInput
                      value={currentMessage}
                      onChange={handlechangeDes}
                      onSend={handleSend}
                      placeholder="Write a description here"
                      disabled={senddisable}
                      attachButton={false}
                    />
                  ) : (
                    <MessageInput
                      value={aiInput}
                      onChange={(e) => {
                        setAiInput(e);
                      }}
                      onSend={handleSendMessage}
                      placeholder={
                        ailoading ? "Processing..." : "Ask something..."
                      }
                      disabled={ailoading}
                      attachButton={false}
                    />
                  )}
                </ChatContainer>
              </MainContainer>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
